module.exports = __webpack_public_path__ + "img/gg.49e31406.png";